module.exports = __webpack_public_path__ + "static/media/associacao_fornecedor.6b57d569.svg";